enum MetricEnum {
  AppInit = 'app-init',
  AppLoading = 'app-loading',
}

const track =
  (window.performance && window.performance.mark && window.performance.measure) || false;

const s = (m: MetricEnum) => m + '-start';
const e = (m: MetricEnum) => m + '-end';

export const start = (m: MetricEnum) => track && performance.mark(s(m));
export const end = (m: MetricEnum) => {
  if (!track) {
    return;
  }
  performance.mark(e(m));
  performance.measure(m, s(m), e(m));
};

export const AppLoading = () => start(MetricEnum.AppLoading);
export const AppLoaded = () => end(MetricEnum.AppLoading);

export const AppInit = () => start(MetricEnum.AppInit);
export const AppInited = () => end(MetricEnum.AppInit);
